import script from "./RetornoStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./RetornoStatus.vue?vue&type=script&setup=true&lang=ts"

import "./RetornoStatus.vue?vue&type=style&index=0&id=2748148e&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2748148e"]])

export default __exports__